import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent, implementFunction } from "../../../../framework/core/mvvm/module_base";
import ActivityExtentView from "./activity_extent_view";
import ModuleManager from "../../../../framework/core/module_manager";
import AppController from "../../../../sdk/app_controller";
import ActivityUtil from "../activity/activity_util";
import ModelData from "../../../public/model_data";
import LoaclStorage from "../../../../manager/local_storage";
import Utility from "../../../../utility/utility";
import AppData from "../../../public/const/app_data";
import Customer from "../customer/customer";
import SdkManager from "../../../../manager/sdk_manager";
import LanguageManager from "../../../../manager/language_manager";
import UserDataManager, { IUserCurrencyData } from "../../../../manager/user_manager";

const { ccclass, property } = cc._decorator;

@ccclass
@moduleInit("ActivityExtent")
export default class ActivityExtent extends ModuleBase<ActivityExtentView, null> {

    _score = 0
    _jumpStore: number = 0
    extentData

    _beforeBindSocialAccountOwerGold = 0;

    constructor() {
        super();
        this.layer = ViewLayer.High;
        this.windowPrefabResPath = "package/hall/module/activity/activityExtent";
        this.viewType = ActivityExtentView;
        this.modelType = null;
        this.needAnim = false
        this.needViewMask = false
    }
    protected onButtonClickName(name: string) {
        if (name.indexOf("xing") > -1) {
            let index = parseInt(name.substr(4, 1))
            this.view.clickXing(index)
            this._score = index
        }
    }
    @bindButtonClickEvent("buttonScore")
    buttonScore() {
        if (CC_JSB && this._score == 5) {
            this._jumpStore = 1
            AppController.instance.requestEvaluate()
        } else {
            if (this._score > 0) {
                this.requestScoreReward()
            }
        }
    }

    @bindButtonClickEvent("buttonDailyGet")
    buttonDailyGet() {
        let code = this.view.dailyCodeInput.string
        if (code.length == 4) {
            this.requestCodeReward(code)
        } else {
            ModuleManager.instance.toastKey("activity_code_tips");  //请输入正确的暗号
        }
    }
    @bindButtonClickEvent("buttonGotoFacebook")
    buttonGotoFacebook() {
        AppController.instance.openFacebookUrl("https://www.facebook.com/bigwingame", "103698947894958")
        if (!CC_JSB) {
            cc.sys.openURL("https://www.facebook.com/bigwingame")
        } else {
            if ((cc.sys.os == cc.sys.OS_ANDROID && Utility.version_judge(AppData.appVersion, "1.2.6"))) {
                AppController.instance.startApp("fb://faceweb/f?href=https://www.facebook.com/bigwingame")
            } else if (cc.sys.os == cc.sys.OS_IOS && Utility.version_judge(AppData.appVersion, "1.3.1")) {
                AppController.instance.startApp("fb://profile/103698947894958")
            } else {
                cc.sys.openURL("https://www.facebook.com/bigwingame")
            }
        }
    }

    @bindButtonClickEvent("buttonLine")
    buttonBindLine() {
        this._beginBindSocialAccount("line")
    }
    @bindButtonClickEvent("buttonFacebook")
    buttonBindFacebok() {
        this._beginBindSocialAccount("facebook")
    }

    @bindButtonClickEvent("buttonCustom")
    buttonCustomer() {
        ModuleManager.instance.showModule<Customer>(Customer, {
            "customerType": 1,
        })
    }

    @implementFunction('onSelfCurrencyDataUpdate')
    protected onSelfDataUpdate(data: IUserCurrencyData) {
        if (this._beforeBindSocialAccountOwerGold != 0 && data.chip - this._beforeBindSocialAccountOwerGold > 0) {
            let dataList = [{ type: 6, num: data.chip - this._beforeBindSocialAccountOwerGold }]
            ModuleManager.instance.showModuleName('DialogReceive', dataList)
        }
        this._beforeBindSocialAccountOwerGold = 0
    }

    _beginBindSocialAccount(type) {
        if (!ModelData.instance.needBindSocialAccount) {
            ModuleManager.instance.toast(LanguageManager.t("login_visitor_has_bind_social_account"))
            return
        }
        let self = this
        SdkManager.instance.setSdkLoginCallback((param) => {
            self.bindSocialAccount(param)
        })
        cc.sys.isNative && SdkManager.instance.requestNativeFunc(type, "req_login");
    }

    //mobile/user/passport/doBindPassportInfo
    bindSocialAccount(param) {
        this._beforeBindSocialAccountOwerGold = UserDataManager._selfCurrencyData.chip
        let requestData: IHttpRequestData = {
            baseUrl: "user/passport/doBindPassportInfo?",
            params: {
                data: param,
            },
            showNetPrompt: true
        }
        this.apiHttpGet(requestData, (respone) => {
            if (respone.data) {
                ModelData.instance.needBindSocialAccount = false
                LoaclStorage.setString("_userLoginVisitNeedBindSocialAccount?" + ModelData.instance.roleData.id, "hasBind")
            }
            cc.log(respone)
            // LoaclStorage.setNumber("AUTO_JOIN_CLUB_ID", clubCode, true)
        })
    }

    onInit() {
    }

    private bindEvent() {
        let self = this
        this.eventBind("game_event_show", function (show) {
            if (show) {
                self.onApplicationShow()
            } else {
                if (this._jumpStore == 1) {
                    this._jumpStore = 2
                }
            }
        })

    }
    onShow(intentData) {
        this.extentData = intentData
        this._beforeBindSocialAccountOwerGold = 0
        this.view.initView(intentData.activity)
        if (intentData.activity == "score") {
            let score = this.getlocalScore()
            if (score == 0 && !ModelData.instance.isAppScore) {
                this.getAppScore()
            } else {
                this.view.initScoreView(this._score, score)
            }
        }

        this.bindEvent();
    }

    protected onHide() {
        this._beforeBindSocialAccountOwerGold = 0
    }

    onApplicationShow() {
        if (this._jumpStore == 2) {
            this._jumpStore = 0
            this.requestScoreReward()
        }
    }

    setlocalScore(score) {
        let str = `PLayerAppScore_id_${ModelData.instance.roleData.id}`
        LoaclStorage.setString(str, score + "")
    }
    getlocalScore() {
        let str = `PLayerAppScore_id_${ModelData.instance.roleData.id}`
        let s = LoaclStorage.getString(str, "0")
        return parseInt(s)
    }
    getAppScore() {
        let self = this
        ActivityUtil.getAppScore(function (data) {
            self.setlocalScore(data.starNum)
            self.view.initScoreView(self._score, data.starNum)
        }, function () { }, this)
    }
    requestScoreReward() {
        let self = this
        ActivityUtil.getAppScoreReward(this._score, function () {
            ModuleManager.instance.toastKey("player_score_game");
            self.view.scoreFinish()
            ModelData.instance.isAppScore = false
            self.extentData.showRedPoint = false
            self.eventDispatch('refresh_activity_redpoint')
            self.setlocalScore(self._score)
        }, function (errr) {
            ModuleManager.instance.toast(errr.msg);
            if (errr.code == "X00161") {
                self.view.scoreFinish()
            }
        }, this)
    }

    requestCodeReward(code) {
        let self = this
        ActivityUtil.getActivationReward(code, function (data) {
            ModelData.instance.isActivationAward = false
            self.extentData.showRedPoint = false
            self.eventDispatch('refresh_activity_redpoint')
            self.getSelfCurrencyData()
            self.goodsDeal(data)
        }, function (data) {
            ModuleManager.instance.toast(data.msg);  //请输入正确的暗号
        }, this)
    }



    goodsDeal(data) {
        let goods = new Array()
        if (data.awardAccountType != undefined) {
            if (data.awardAccountAmount > 0) {
                goods.push({ type: data.awardAccountType, num: data.awardAccountAmount })
            }
        }
        if (data.tomatoMobileGoodsVo != undefined) {
            if (data.tomatoMobileGoodsVo.num > 0) {
                if (data.tomatoMobileGoodsVo.goodsType == "currency") {
                    goods.push({ type: data.tomatoMobileGoodsVo.goodsAccountType, num: data.tomatoMobileGoodsVo.num })
                }
                if (data.tomatoMobileGoodsVo.goodsType == "item") {
                    goods.push({ type: 10, itemCode: data.tomatoMobileGoodsVo.sourceCode, num: data.tomatoMobileGoodsVo.num })
                }
            }
            for (let i = 0; i < data.tomatoMobileGoodsVo.giftList.length; i++) {
                let d = data.tomatoMobileGoodsVo.giftList[i]
                if (d.num > 0) {
                    if (d.gitType == "currency") {
                        goods.push({ type: d.giftAccountType, num: d.num })
                    }
                    if (d.gitType == "item") {
                        goods.push({ type: 10, itemCode: d.sourceCode, num: d.num })
                    }
                }
            }
        }
        ModuleManager.instance.showModuleName('DialogReceive', goods)
    }

}
